export default __webpack_public_path__ + "static/media/Addnew.4e25ca7d.png";